import { useState } from "react";
import { Plus } from "lucide-react";

export function PracticeFaq({ faqs }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="border-t border-[#141414]" data-testid="practice-faq">
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="border-b border-[#141414]">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              data-testid={`practice-faq-q-${i + 1}`}
              className="w-full text-left grid grid-cols-12 gap-4 items-start py-7 group"
            >
              <span className={`col-span-2 lg:col-span-1 chapter-num pt-1.5 ${isOpen ? "text-[#C84C35]" : ""}`}>{String(i + 1).padStart(2, "0")}</span>
              <span className={`col-span-9 lg:col-span-10 font-serif text-2xl lg:text-3xl leading-tight tracking-tight transition-colors duration-500 ${isOpen ? "text-[#F4F1EB]" : "text-[#F4F1EB] group-hover:text-[#C84C35]"}`}>{f.q}</span>
              <span className="col-span-1 flex justify-end text-[#66635C] group-hover:text-[#C84C35] transition-colors pt-1">
                <Plus size={20} strokeWidth={1.25} className={`transition-transform duration-500 ${isOpen ? "rotate-45 text-[#C84C35]" : ""}`} />
              </span>
            </button>
            <div
              aria-hidden={!isOpen}
              style={{ maxHeight: isOpen ? 800 : 0, opacity: isOpen ? 1 : 0, transition: "max-height 0.7s cubic-bezier(0.76,0,0.24,1), opacity 0.5s ease", overflow: "hidden" }}
            >
              <div className="grid grid-cols-12 gap-4 pb-8">
                <div className="hidden lg:block lg:col-span-1" />
                <p data-testid={`practice-faq-a-${i + 1}`} className="col-span-12 lg:col-span-9 text-[#A19D94] text-base lg:text-lg leading-relaxed">{f.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
